import { render, staticRenderFns } from "./addserver.vue?vue&type=template&id=d0403864&scoped=true&"
import script from "./addserver.vue?vue&type=script&lang=js&"
export * from "./addserver.vue?vue&type=script&lang=js&"
import style0 from "./addserver.vue?vue&type=style&index=0&id=d0403864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0403864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0403864')) {
      api.createRecord('d0403864', component.options)
    } else {
      api.reload('d0403864', component.options)
    }
    module.hot.accept("./addserver.vue?vue&type=template&id=d0403864&scoped=true&", function () {
      api.rerender('d0403864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/packageCode/components/addserver.vue"
export default component.exports